module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/media/quantum-cubic-video.945c6865.mp4";